import { Component, inject, OnInit } from '@angular/core';
import { MapComponent } from '../../shared/map/map.component';
import { MenuNavComponent } from '../../shared/menu-nav/menu-nav.component';
import { MoreComponent } from '../../shared/more/more.component';
import { PlannerComponent } from '../../shared/planner/planner.component';
import { CustomRouteMobileViewsStateService } from './services/custom-route-mobile-views-state.service';
import { CUSTOM_ROUTE_MOBILE_MAP } from './config/constants';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { CustomRouteMobileViews } from './interfaces/custom-route-mobile.interface';
import { ChatbotCustomRouteMobileComponent } from "./components/chatbot-custom-route-mobile/chatbot-custom-route-mobile.component";
import { GeolocationRequestService } from 'src/app/pages/register-user/components/register-user-form-mobile/services';
import { GeolocationRequestComponent } from "src/app/pages/register-user/components/register-user-form-mobile/components";
import { WelcomePlannerViewComponent } from "../../shared";
import { CustomRouteService } from '../../services/custom-route.service';

@Component({
  selector: 'app-custom-route-mobile',
  standalone: true,
  imports: [
    MenuNavComponent,
    PlannerComponent,
    MapComponent,
    MoreComponent,
    ChatbotCustomRouteMobileComponent,
    GeolocationRequestComponent,
    WelcomePlannerViewComponent
],
  templateUrl: './custom-route-mobile.component.html',
  styleUrls: ['./custom-route-mobile.component.scss'],
})
export class CustomRouteMobileComponent implements OnInit {
  private _customRouteService = inject(CustomRouteService);
  private _customRouteMobileViewsStateService = inject(CustomRouteMobileViewsStateService);
  private _sessionStorageService = inject(SessionStorageService);
  private _geolocationRequestService = inject(GeolocationRequestService);
  
  protected mobileViewsState = this._customRouteMobileViewsStateService.mobileViewsState;
  protected isGeolocationView = this._geolocationRequestService.isGeolocationView;
  protected isWelcomeViewShown = this._customRouteService.isWelcomeViewShown
  
  public customRouteMobileViews = CUSTOM_ROUTE_MOBILE_MAP;
  
  ngOnInit(): void {
    // Get the view from session storage in case the user refreshes the page
    const mobileViewsStateSessionStorage = this._sessionStorageService.getItem('customRouteMobileViewsState') as CustomRouteMobileViews;
    if (mobileViewsStateSessionStorage) {
      this._customRouteMobileViewsStateService.mobileViewsState.set(mobileViewsStateSessionStorage);
    }
  }
}
